// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__HCLI2","pageLoadingContainer":"LoadingSpinner_pageLoadingContainer__CgSGM"};